// panel name
const MAIN_LAYOUT = 'main';
const TODO_LAYOUT = 'todo';
const APP_TITLE = 'Pharmaceutical Disclosure Service Console';

// Request configs
const REQUEST = {
  ACCESS_HEADER: 'X-Access-Token',
  RESULTS: 'results'
};

const APP_URL = {
  // UPLOAD_PATH: process.env.REACT_APP_UPLOAD_PATH
  UPLOAD_PATH: window.Configs.UPLOAD_PATH + '/upload/company/logo',
  FAVICON_UPLOAD_PATH: window.Configs.UPLOAD_PATH + '/upload/company/favicon'
};

// form name
const FORMS = {
  login: 'login',
  loginOTP: 'loginOTP',
  register: 'register',
  forgotPassword: 'ForgotPassword',
  companySettingForm: 'CompanySettingForm',
  userAccountSettingForm: 'UserAccountSettingForm',
  changePasswordForm: 'ChangePasswordForm',
  changeEmailForm: 'ChangeEmailForm',
  uploadDisclosureForm: 'UploadDisclosureForm',
  uploadPatientForm: 'UploadPatientForm',
  dataDetailForm: 'DataDetailForm',
  disclosureMessageTermOfUsageForm: 'DisclosureMessageTermOfUsageForm',
  patientMessageTermOfUsageForm: 'PatientMessageTermOfUsageForm',
  disclosureGroupTitleDescriptionForm: 'DisclosureGroupTitleDescriptionForm',
  patientGroupTitleDescriptionForm: 'patientGroupTitleDescriptionForm',
  disclosureTableHeadingForm: 'DisclosureTableHeadingForm',
  patientTableHeadingForm: 'PatientTableHeadingForm',
  pageTitleForm: 'PageTitleForm',
  searchForm: 'SearchForm',
  companyDetailForm: 'CompanyDetailForm',
  companyCreateForm: 'CompanyCreateForm',
  companyUserDetailForm: 'CompanyUserDetailForm',
  adminAccountSettingForm: 'AdminAccountSettingForm',
  dashboardFilterForm: 'DashboardFilterForm',
  tabPageTitleForm: 'TabPageTitleForm',
  securityPolicyForm: 'SecurityPolicyForm'
};

// paging params
const TABLE = {
  DEFAULT_PAGE_NUMBER: 0,
  DEFAULT_PAGE_SIZE: 10
};

const STORAGE_KEYS = {
  session: 'session',
  layout: 'layout',
  user: 'user',
  disclosureAgreement: 'disclosureAgreement',
  patientAgreement: 'patientAgreement',
  unique: 'unique',
  domain: 'domain',
  uniqueDate: 'uniqueDate',
  autoLogout: 'autoLogout',
  lastActivity: 'lastActivity'
};

// Default notification config [see usage at notificationSaga.showNotification()]
const DEFAULT_NOTIFICATION_CONFIG = {
  message: 'api.error.unknown',
  level: 'error',
  position: 'br',
  autoDismiss: 5
};

const PATTERNS = {
  EMAIL_PATTERN: /^(?!.{65})[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/,
  DOMAIN_PATTERN: /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/,
  IP_PATTERN: /^([01]?\d\d?|2[0-4]\d|25[0-5])\.([01]?\d\d?|2[0-4]\d|25[0-5])\.([01]?\d\d?|2[0-4]\d|25[0-5])\.([01]?\d\d?|2[0-4]\d|25[0-5])$/,
  PASSWORD_PATTERN: /^.{8,}$/,
  PASSWORD_UPPER: /^(?=.*[A-Z]).{8,}$/,
  PASSWORD_LOWER: /^(?=.*[a-z]).{8,}$/,
  PASSWORD_NUMBER: /^(?=.*\d).{8,}$/,
  DATE_PATTERN: /^(([01])\d)\/(([012])\d)\/((19|20)\d{2})$/,
  DATE_FORMAT: 'MM/DD/YYYY',
  DATE_TIME_FORMAT: 'DD/MM/YYYY HH:mm:ss',
  SECTION_PATTERN: /[A-E][1-9]-[1-9]|[A-E][1-9]/g,
  G_SPECIAL_CHAR: /[^A-Za-z0-9]/g
};

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const SHORT_MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];

export const MONTHS_OBJ = [
  {
    label: 'month.1',
    number: 1
  },
  {
    label: 'month.2',
    number: 2
  },
  {
    label: 'month.3',
    number: 3
  },
  {
    label: 'month.4',
    number: 4
  },
  {
    label: 'month.5',
    number: 5
  },
  {
    label: 'month.6',
    number: 6
  },
  {
    label: 'month.7',
    number: 7
  },
  {
    label: 'month.8',
    number: 8
  },
  {
    label: 'month.9',
    number: 9
  },
  {
    label: 'month.10',
    number: 10
  },
  {
    label: 'month.11',
    number: 11
  },
  {
    label: 'month.12',
    number: 12
  }
];

export const ROOT_GROUPS = ['A', 'B', 'C', 'D', 'E'];

export const GROUP_OBJECT = {
  DISCLOSURE: 'disclosure',
  PATIENT: 'patient'
};
export const GROUP_TYPES = [GROUP_OBJECT.DISCLOSURE, GROUP_OBJECT.PATIENT];
export const SECTION_TYPES = {
  DISCLOSURE: {
    type: GROUP_OBJECT.DISCLOSURE,
    value: 1
  },
  PATIENT: {
    type: GROUP_OBJECT.PATIENT,
    value: 2
  }
};

export const FILE_STATUS = {
  DONE: 0,
  PENDING: 2,
  PROGRESSING: 1
};

const USER_CONFIG = {
  SYSTEM_ADMIN: {
    roleLevel: 1,
    landingPage: '/admin/companies'
  },
  COMPANY_ADMIN: {
    roleLevel: 2,
    landingPage: '/company/dashboard'
  }
};

const LANGUAGES = [
  {
    value: 'en',
    label: 'lang.en'
  },
  {
    value: 'ja',
    label: 'lang.ja'
  }
];

const DOWNLOAD_FILE_TYPES = [
  'application/octet-stream',
  'text/csv',
  'application/pdf',
  'text/plain'
];

const UPLOAD_FILE_TYPES = {
  CSV: 'csv',
  PDF: 'pdf'
};

const PATIENT_UPLOAD_PATH = '/upload/company/patient-group';

const UPDATE_DATA_PROGRESS_STATUS = {
  DONE: 2,
  PENDING: 0,
  PROGRESS: 1
};

export {
  //* *********//
  MAIN_LAYOUT,
  TODO_LAYOUT,
  APP_TITLE,
  //* *********//
  REQUEST,
  //* *********//
  FORMS,
  //* *********//
  TABLE,
  //* *********//
  STORAGE_KEYS,
  //* *********//
  DEFAULT_NOTIFICATION_CONFIG,
  //* *********//
  PATTERNS,
  USER_CONFIG,
  APP_URL,
  LANGUAGES,
  DOWNLOAD_FILE_TYPES,
  UPLOAD_FILE_TYPES,
  PATIENT_UPLOAD_PATH,
  UPDATE_DATA_PROGRESS_STATUS
};
